import Highcharts from 'highcharts'
import exportingInit from 'highcharts/modules/exporting'
import exportData from 'highcharts/modules/export-data'

Highcharts.SVGRenderer.prototype.symbols.download = function(x, y, w, h) {
  var path = [
    'M',
    x + w * 0.5,
    y,
    'L',
    x + w * 0.5,
    y + h * 0.7,
    'M',
    x + w * 0.3,
    y + h * 0.5,
    'L',
    x + w * 0.5,
    y + h * 0.7,
    'L',
    x + w * 0.7,
    y + h * 0.5,
    'M',
    x,
    y + h * 0.9,
    'L',
    x,
    y + h,
    'L',
    x + w,
    y + h,
    'L',
    x + w,
    y + h * 0.9
  ]
  return path
}

exportingInit(Highcharts)
exportData(Highcharts)

// Chrome Trusted Types bug: the policy callback created at module init becomes "no longer
// runnable" when window.print() triggers a chart redraw. Replace parseMarkup with the
// equivalent innerHTML fallback that the original code uses when DOMParser is unavailable.
if (window.trustedTypes) {
  Highcharts.AST.prototype.parseMarkup = function(html) {
    var nodes = []
    var div = document.createElement('div')
    div.innerHTML = html.trim()
    var walk = function(node, arr) {
      var tag = node.nodeName.toLowerCase()
      var r = { tagName: tag }
      if (tag === '#text') r.textContent = node.textContent || ''
      if (node.attributes) {
        var attrs = {}
        ;[].forEach.call(node.attributes, function(a) {
          attrs[a.name] = a.value
        })
        r.attributes = attrs
      }
      if (node.childNodes.length) {
        var children = []
        ;[].forEach.call(node.childNodes, function(c) {
          walk(c, children)
        })
        children.length && (r.children = children)
      }
      arr.push(r)
    }
    ;[].forEach.call(div.childNodes, function(node) {
      walk(node, nodes)
    })
    return nodes
  }
}
